import { useCallback } from 'react';
import formatRelative from 'date-fns/formatRelative';
import fr from 'date-fns/locale/fr';

export default function useRelativeDate() {
  return useCallback((date, baseDate = new Date(), options = {}) => {
    return formatRelative(date, baseDate, { locale: fr, ...options });
  }, []);
}
